import ApiClient from './ApiClient';
import AuthApiClient from './AuthApiClient';

class ApiFactory {
    create() {
        const api = new ApiClient();
        return api;
    }

    createAuth() {
        const api = new AuthApiClient();
        return api;
    }
}
export default ApiFactory;